import { render, staticRenderFns } from "./CouvertureHistory.vue?vue&type=template&id=4c830837"
import script from "./CouvertureHistory.vue?vue&type=script&lang=js"
export * from "./CouvertureHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports